import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=daa97502&scoped=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AppSideMenu.vue?vue&type=style&index=0&id=daa97502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa97502",
  null
  
)

export default component.exports